/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const GET_ALL_REBATE_PROGRAMS = 'GET_ALL_REBATE_PROGRAMS';
export const SET_REQ_URA_DATA = 'SET_REQ_URA_DATA';
export const GET_MANUFACTURERS_BY_REQ_URA_CAL =
  'GET_MANUFACTURERS_BY_REQ_URA_CAL';
export const CALCULATE_INVOICE = 'CALCULATE_INVOICE';
export const SET_DEFAULT_QTR = 'SET_DEFAULT_QTR';
export const RESET_REQUEST_URA_CALCULATION_STORE =
  'RESET_REQUEST_URA_CALCULATION_STORE';
export const SET_ERROR_MESSAGES_REQ_URA_CAL = 'SET_ERROR_MESSAGES_REQ_URA_CAL';
